import { render, staticRenderFns } from "./ClubManager.vue?vue&type=template&id=1edf97a1&scoped=true&"
import script from "./ClubManager.vue?vue&type=script&lang=js&"
export * from "./ClubManager.vue?vue&type=script&lang=js&"
import style0 from "./ClubManager.vue?vue&type=style&index=0&id=1edf97a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edf97a1",
  null
  
)

export default component.exports